module.exports = __webpack_public_path__ + "static/media/call_back_confirm.39d0f64f.svg";